import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { ACCESS } from "constants/variable";

const SidebarContent = props => {
  const [role, setRole] = useState("");
  const userRole = localStorage.getItem("userRole");

  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");

    const sidebarPageMapping = {
      "/edit-parent": "/parent-list",
      "/add-parent": "/parent-list",
      "/add-parent-registration": "/registration",
      "/add-student": "/student",
      "/edit-student": "/student",
      "/add-users": "/users",
      "/edit-users": "/users",
      "/add-cluster": "/cluster",
      "/edit-cluster": "/cluster",
      "/add-program-type": "/program-type",
      "/edit-program-type": "/program-type",
      "/add-category": "/category",
      "/edit-category": "/category",
      "/add-centre": "/centre",
      "/edit-centre": "/centre",
      "/add-feestructure": "/feestructure",
      "/edit-feestructure": "/feestructure",
      "/add-discount": "/discount",
      "/edit-discount": "/discount",
      "/add-academicyear": "/academic-year",
      "/edit-academicyear": "/academic-year",
      "/add-payment": "/payment",
      "/edit-payment": "/payment",
      "/student-payment-allocation": "/payment",
      "/fees-paid": "/fees-paid",
      "/edit-fees-paid": "/fees-paid",
      "/edit-registration": "/registration",
      "/add-feetype": "/fees-type",
      "/edit-feetype": "/fees-type",
      "/apply-late-fee": "/apply-late-fee",
      "/view-payment-status": "/payment-status",
      "/edit-observation": "/observation",
      "/student-discount-allocation": "/discount",
      "/student-discount-unallocation": "/discount",
      "/student-feetype-allocation": "/fees-type",
      "/student-feetype-unallocation": "/fees-type"
    };
    removeActivation(items);

    if (sidebarPageMapping[pathName]) {
      for (let i = 0; i < items.length; ++i) {
        if (items[i].pathname === sidebarPageMapping[pathName]) {
          matchingMenuItem = items[i];
          break;
        }
      }
    } else {
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
    }
    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <>
                <li>
                  <Link to={`/dashboard`}>
                    <i className="bx bx-home-circle"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
              </>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-money"></i>
                  <span>{props.t("Registration")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/registration">
                      <i className="bx bx-detail"></i>
                      <span>{props.t("Student Registration")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/observation">
                      <i className="bx bx-clipboard"></i>
                      <span>{props.t("Observation")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            {ACCESS.ALL_CENTRE_ACCESS.includes(userRole) && (
              <li>
                <Link to="/student">
                  <i className="bx bx-group"></i>
                  <span>{props.t("Student")}</span>
                </Link>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/parent-list">
                  <i className="bx bx-id-card"></i>
                  <span>{props.t("Parent")}</span>
                </Link>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/users">
                  <i className="bx bx-user-circle"></i>
                  <span>{props.t("Users")}</span>
                </Link>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-money"></i>
                  <span>{props.t("Fees and Payments")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/payment-status">
                      <i className="bx bx-id-card"></i>
                      <span>{props.t("Payment Status")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/fees-paid">
                      <i className="bx bxs-receipt"></i>
                      <span>{props.t("Approve Screenshots by Parents")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin-manual-payment">
                      <i className="bx bx-credit-card"></i>
                      <span>{props.t("Manual Entries by admin")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/apply-late-fee">
                      <i className="bx bx-time"></i>
                      <span>{props.t("Apply Re-registration Fees")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            {ACCESS.ADMIN_MANAGEMENT_CENTRE_HEAD.includes(userRole) && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-building"></i>
                  <span>{props.t("Organization")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/cluster">
                      <i className="bx bx-network-chart"></i>
                      <span>{props.t("Cluster")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/category">
                      <i className="bx bx-layer"></i>
                      <span>{props.t("Category")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/program-type">
                      <i className="bx bx-list-ul"></i>
                      <span>{props.t("Program Type")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/centre">
                      <i className="bx bx-buildings"></i>
                      <span>{props.t("Centre")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/feestructure">
                      <i className="bx bx-dollar"></i>
                      <span>{props.t("Tuition Fee")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/discount">
                      <i className="bx bx-purchase-tag"></i>
                      <span>{props.t("Discount")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/fees-type">
                      <i className="bx bx-wallet"></i>
                      <span>{props.t("Other Fees")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/academic-year">
                      <i className="fas fa-graduation-cap"></i>
                      <span>{props.t("Academic Year")}</span>
                    </Link>
                  </li>
                  {/* <li className="submenu ">
                    <a href="#" className="d-flex">
                      <i className="bx bx-money"></i>
                      <span>{props.t("Fees Management")}</span>
                      <i className="bx bx-chevron-down"></i>
                    </a>
                    <ul className="submenu-list">
                      <li>
                        <Link to="/fees-type">
                          <i className="bx bx-wallet"></i>
                          <span>{props.t("Other Fees")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/other-fees-due-list">
                          <i className="bx bx-credit-card-front"></i>
                          <span>{props.t(" Other Fees Due List")}</span>
                        </Link>
                      </li>
                    </ul>
                  </li> */}
                  {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
                    <li>
                      <Link to="/payment">
                        <i className="bx bx-money"></i>
                        <span>{props.t("Payment Channel")}</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <li>
                <Link to="/bank-account-detail">
                  <i className="bx bxs-bank"></i>
                  <span>{props.t("Bank Detail")}</span>
                </Link>
              </li>
            )}
            {ACCESS.ADMIN_OR_MANAGEMENT.includes(userRole) && (
              <>
                <li className="menu-title">{props.t("Settings")}</li>
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-cog"></i>
                    <span>{props.t("Application Setting")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/email">
                        <i className="bx bx-mail-send"></i>
                        <span>{props.t("EMail")}</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/notification">
                    <i className="bx bx-bell"></i>
                    <span>{props.t("Notification")}</span>
                  </Link>
                </li>
              </>
            )}
            {ACCESS.CENTER_HEAD.includes(userRole) && (
              <li>
                <Link to="/scheduler">
                  <i className="bx bx-time-five"></i>
                  <span>{props.t("Schedule Reminder")}</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));